$mol_stack_demo $mol_example_small
	sub /
		<= Collage $mol_stack
			sub /
				<= Back $mol_image uri \https://cataas.com/cat
				<= Front $mol_view sub / \❤🧡💛💚💙💜🤎🖤
	aspects /
		\Widget/Layout
